// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1fzXz","upload":"Small_upload__e7w3w","imageWrap":"Small_imageWrap__3u122","removeBtn":"Small_removeBtn__s3uca"};